import { render, staticRenderFns } from "./MotorVehicleDetails.vue?vue&type=template&id=448807c8&"
import script from "./MotorVehicleDetails.vue?vue&type=script&lang=js&"
export * from "./MotorVehicleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports